/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 783YKJdyRRPxZbx3qiNi5Q

import { createUseStyleTokens } from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 783YKJdyRRPxZbx3qiNi5Q/projectModule

import projectcss from "./plasmic_plasmic_kit_component_props_section.module.css"; // plasmic-import: 783YKJdyRRPxZbx3qiNi5Q/projectcss

import plasmic_plasmic_kit_design_system_css from "../PP__plasmickit_design_system.module.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import plasmic_plasmic_kit_color_tokens_css from "../plasmic_kit_q_4_color_tokens/plasmic_plasmic_kit_q_4_color_tokens.module.css"; // plasmic-import: 95xp9cYcv7HrNWpFWWhbcv/projectcss

const data = {
  base: `${projectcss.plasmic_tokens} ${plasmic_plasmic_kit_design_system_css.plasmic_tokens} ${plasmic_plasmic_kit_color_tokens_css.plasmic_tokens}`,
  varianted: [],
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
